import { render } from "./DetalleFarmacia.vue?vue&type=template&id=a0fe8610&scoped=true"
import script from "./DetalleFarmacia.vue?vue&type=script&lang=js"
export * from "./DetalleFarmacia.vue?vue&type=script&lang=js"

import "./DetalleFarmacia.vue?vue&type=style&index=0&id=a0fe8610&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fe8610"]])

export default __exports__